import React, { FC } from 'react';
import { Tabs } from 'antd';
import { useRedux } from 'use-redux';
import { I18n } from 'react-redux-i18n';

import { BEMHelper } from '@utils/customBEMHelper';
import { SUCCESS_STATUSES } from '@constants/payments';
import MovingPayment from './movingPayment';
import { TABS } from './constants';
import { IExpandedPaymentProps } from './interfaces';

import styles from './styles.module.scss';
import ManualPaymentForm from '../manualPaymentForm';

const classes = new BEMHelper({
  name: 'payment-expanded',
});

const { TabPane } = Tabs;

const ExpandedPayment: FC<IExpandedPaymentProps> = ({
  payment,
  handleUpdateManualPayment,
}) => {
  const [
    {
      auth: {
        user: { group },
      },
    },
  ] = useRedux();

  const isAdmin = group === 'admin';
  const isManual = payment.method === 'manual';
  const isSuccess = SUCCESS_STATUSES
    // @ts-ignore
    .includes(payment.status);

  return (
    <div className={styles.root}>
      <Tabs defaultActiveKey={TABS.EditPayment} className={classes()}>
        {isManual && isAdmin && (
          <TabPane
            tab={I18n.t('admin.paymentsStats.editPaymentTab')}
            key={TABS.EditPayment}
          >
            <div className={styles.rootEditForm}>
              <ManualPaymentForm
                payment={payment}
                onSubmit={handleUpdateManualPayment}
              />
            </div>
          </TabPane>
        )}

        {isSuccess && !isManual && (
          <TabPane
            tab={I18n.t('admin.paymentsStats.movePaymentTab')}
            key={TABS.MovePayment}
          >
            <MovingPayment payment={payment} />
          </TabPane>
        )}
      </Tabs>
    </div>
  );
};

export default ExpandedPayment;
